import * as R from 'ramda'
import Moment from 'moment'
import Store from '@helpers/StorageHelper'
import {
  STORAGE_KEY
} from '@constants'

class Basket {
  constructor () {
    this.key = STORAGE_KEY
    const data = Store.get(this.key) || `[]`
    this.items = JSON.parse(data)
  }

  // writes whole array to LS
  addItems (items) {
    // only allow arrays to be added to store
    if (R.not(R.is(Array, items))) {
      console.log('Basket addItems requires an array')
      return
    }

    this.items = items
    Store.set(this.key, JSON.stringify(this.items))

    this._emitUpdate()
  }

  getItems () {
    // convert all dates to moment dates before returning
    const items = R.map(item => {
      const itemObj = {...item}
      itemObj.startDate = Moment(item.startDate)
      itemObj.endDate = Moment(item.endDate)
      return itemObj
    }, this.items)

    return items
  }

  countItems () {
    // return total of all quantities within each basket listing
    if (R.isEmpty(this.items)) {
      return 0
    }

    return R.pipe(
      R.map(item => Number(item.quantity)),
      R.sum
    )(this.items)
  }

  removeItem (index) {
    this.items.splice(index, 1)
    Store.set(this.key, JSON.stringify(this.items))

    this._emitUpdate()
  }

  _emitUpdate () {
    const event = new Event('updateBasket')
    document.dispatchEvent(event)
  }
}

export default new Basket()



// WEBPACK FOOTER //
// ./src/helpers/BasketHelper.js